<template>
  <div class="food-item-edit">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            {{ id === '0' ? $t("General.Create") : $t("General.Edit") }}{{ $t("OrderFood.FoodCategory") }}
          </div>
        </div>
        <div class="right food-item-edit__right">
          <div v-if="id !== '0'">
            <el-tooltip class="item" effect="dark" :content="$t('OrderFoodMenuEdit.PleaseSwitchDisabledAndDelete')" placement="top" :disabled="editForm.isCheck < 1">
              <el-button
                class="mr-24"
                plain
                type="danger"
                size="mini"
                :disabled="editForm.isCheck === 1"
                @click="handleClickDelete"
              >
                {{ $t("General.Delete") }}
              </el-button>
            </el-tooltip>
          </div>
          <div class="food-item-edit__required">
            <div>*</div>
            <div>{{ $t('OrderFoodItemManagement.AsRequired') }}</div>
          </div>
        </div>
      </div>
      <div class="food-item-edit__form-wrapper">
        <el-form
          ref="editFormRef"
          class="food-item-edit__form-el"
          :model="editForm"
          status-icon
          @submit.native.prevent
        >
          <div class="food-item-edit__form-label mb-12">
            <div class="food-item-edit__required">
              <div>*</div>
            </div>
            <div>{{ $t('OrderFood.FoodCategory') }}</div>
          </div>
          <el-form-item
            prop="name"
            :rules="{ required: true, message: $t('OrderFoodMenuEdit.PleaseEnterFoodCategory'), trigger: ['change', 'blur'] }"
          >
            <el-input
              v-model="editForm.name"
              maxlength="10"
              :placeholder="$t('OrderFoodMenuEdit.MenuNamePlaceholder')"
              class="food-item-edit__menu-name-input"
            />
            <el-radio v-model="editForm.isCheck" :label="1">
              {{ $t("OrderFoodItemManagement.Enable") }}
            </el-radio>
            <el-radio v-model="editForm.isCheck" :label="0">
              {{ $t("OrderFoodItemManagement.Disable") }}
            </el-radio>
          </el-form-item>
          <div class="food-item-edit__table-wrapper">
            <ItemsListSortable ref="sortableRef" class="food-item-edit__sortable" @drag-end="handleDragEnd">
              <el-table ref="tableRef" :data="editForm.children" row-key="timestamp">
                <el-table-column width="50" align="left">
                  <div class="food-item-edit__drag-btn">
                    <el-button type="primary" class="drag-handle" icon="el-icon-d-caret" circle size="mini"></el-button>
                  </div>
                </el-table-column>
                <el-table-column :label="$t('OrderFood.FoodItem')">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'children.' + scope.$index + '.name'"
                      :rules="{
                        required: true, message: $t('OrderFoodMenuEdit.PleaseEnterFoodItem'), trigger: ['change', 'blur']
                      }"
                    >
                      <el-input
                        v-model="scope.row.name"
                        maxlength="10"
                        :placeholder="$t('OrderFoodMenuEdit.ItemNamePlaceholder')"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('OrderFoodItemManagement.Status')" width="170">
                  <template slot-scope="scope">
                    <el-form-item
                      prop="isCheck"
                      inline="true"
                    >
                      <el-radio v-model="scope.row.isCheck" :label="1">
                        {{ $t("OrderFoodItemManagement.Enable") }}
                      </el-radio>
                      <el-radio v-model="scope.row.isCheck" :label="0">
                        {{ $t("OrderFoodItemManagement.Disable") }}
                      </el-radio>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('OrderFood.NormalPoints')" width="200">
                  <template slot-scope="scope">
                    <div class="food-item-edit__price-container">
                      <div class="food-item-edit__price-radio-wrapper">
                        <el-radio v-model="scope.row.prices[0].isCheck" :label="1">
                          {{ $t("OrderFoodItemManagement.Enable") }}
                        </el-radio>
                        <el-radio v-model="scope.row.prices[0].isCheck" :label="0">
                          {{ $t("OrderFoodItemManagement.Disable") }}
                        </el-radio>
                      </div>
                      <div>
                        <span v-if="scope.row.prices[0].isCheck">
                          <el-form-item
                            :prop="`children.${scope.$index}.prices.0.unitPrice`"
                            :rules="[
                              {
                                type: 'number', required: true, message: $t('OrderFoodMenuEdit.PleaseEnterPoints', {targetPoint: $t('OrderFood.NormalPoints')}), trigger: ['change', 'blur']
                              },
                              {
                                type: 'number', min: 0, message: $t('OrderFoodMenuEdit.PointsMustBePositive', {targetPoint: $t('OrderFood.NormalPoints')}), trigger: ['change', 'blur']
                              }
                            ]"
                          >
                            <el-input
                              v-model.number="scope.row.prices[0].unitPrice"
                              maxlength="5"
                              :placeholder="$t('OrderFoodMenuEdit.PointsPlaceholder')"
                            />
                          </el-form-item>
                        </span>
                        <span v-else>{{ scope.row.prices[0].unitPrice }}</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('OrderFood.CashPoints')" width="200">
                  <template slot-scope="scope">
                    <div class="food-item-edit__price-container">
                      <div class="food-item-edit__price-radio-wrapper">
                        <el-radio v-model="scope.row.prices[1].isCheck" :label="1">
                          {{ $t("OrderFoodItemManagement.Enable") }}
                        </el-radio>
                        <el-radio v-model="scope.row.prices[1].isCheck" :label="0">
                          {{ $t("OrderFoodItemManagement.Disable") }}
                        </el-radio>
                      </div>
                      <div>
                        <span v-if="scope.row.prices[1].isCheck">
                          <el-form-item
                            :prop="`children.${scope.$index}.prices.1.unitPrice`"
                            :rules="[
                              {
                                type: 'number', required: true, message: $t('OrderFoodMenuEdit.PleaseEnterPoints', {targetPoint: $t('OrderFood.CashPoints')}), trigger: ['change', 'blur']
                              },
                              {
                                type: 'number', min: 0, message: $t('OrderFoodMenuEdit.PointsMustBePositive', {targetPoint: $t('OrderFood.CashPoints')}), trigger: ['change', 'blur']
                              }
                            ]"
                          >
                            <el-input
                              v-model.number="scope.row.prices[1].unitPrice"
                              maxlength="5"
                              :placeholder="$t('OrderFoodMenuEdit.PointsPlaceholder')"
                            />
                          </el-form-item>
                        </span>
                        <span v-else>{{ scope.row.prices[1].unitPrice }}</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('OrderFood.Spec')" align="left" width="150">
                  <template slot-scope="scope">
                    <el-button
                      plain
                      :type="scope.row.displaySpec ? 'primary' : 'info'"
                      size="mini"
                      class="food-item-edit__spec-btn"
                      @click="handleOpenSpecDialog(scope.$index)"
                    >
                      {{ scope.row.displaySpec || $t('OrderFood.Spec') }}
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('OrderFoodItemManagement.Action')" align="left" width="150">
                  <template slot-scope="scope">
                    <el-button
                      plain
                      type="danger"
                      size="mini"
                      @click="handleDeleteOption(scope.$index)"
                    >
                      {{ $t("General.Delete") }}
                    </el-button>
                  </template>
                </el-table-column>
                <template slot="empty">
                  <span></span>
                </template>
              </el-table>
            </ItemsListSortable>
            <div class="food-item-edit__add-btn-container">
              <el-button plain icon="el-icon-plus" type="primary" @click="addMenuOption">
                {{ $t("OrderFoodMenuEdit.CreateFoodItem") }}
              </el-button>
            </div>
          </div>
        </el-form>
      </div>
      <el-divider></el-divider>
      <div class="footer-container">
        <el-button
          round
          @click="handleClickCancel"
        >
          {{ $t("General.Cancel") }}
        </el-button>
        <el-button
          type="primary"
          round
          @click="handleSave"
        >
          {{ $t("General.Store") }}
        </el-button>
      </div>
    </div>
    <SelectSpecDialog ref="selectSpecDialogRef" :target-index="targetMenuItemIndex" :selected-spec="targetMenuItemChooses" @confirm="handleSelectedSpec" />
  </div>
</template>

<script>
import ItemsListSortable from './components/ItemsListSortable.vue'
import SelectSpecDialog from './components/SelectSpecDialog.vue'
import { apiOrderFood } from '@/api/OrderFood'
import { convertKeysToPascalCase, convertKeysToCamelCase } from '@/js/utils/bff'
import { getDisplaySpec } from '@/js/utils/orderFood'
export default {
  name: 'OrderFoodMenuEdit',
  components: {
    ItemsListSortable,
    SelectSpecDialog
  },
  data () {
    return {
      id: '0',
      mode: 'add', // 模式(預設為新增)
      messageTitle: '餐點類別新增',
      editFormRef: null, // 表單實例
      // 表單資料
      editForm: {
        name: '', // 名稱
        originalName: '', // 顯示刪除名稱
        sequence: '', // 排序
        isCheck: 0, // 是否啟用
        children: [] // 品項
      },
      originalEditFormData: '', // 原始表單資料
      deleteChildren: [], // 刪除的品項
      childrenIdTemplate: '00000000-0000-0000-0000-000000000000', // 品項id模板
      sortableRef: null, // 排序實例
      tableRef: null, // 表格實例
      loading: null, // 加載實例
      usedItems: [], // 已使用的項目
      selectSpecDialogRef: null, // 選擇規格對話框實例
      targetMenuItemIndex: -1, // 目前品項索引
      targetMenuItemChooses: [] // 目前品項選擇的規格
    }
  },
  watch: {
    /**
     * 監聽餐點類別啟用狀態
     * 1. 若停用，則底下所有餐點品項一併停用
     * @param {number} val 啟用狀態(0:停用, 1:啟用)
     */
    'editForm.isCheck': function (val) {
      if (!val) {
        this.editForm.children.forEach((item, index) => {
          item.isCheck = 0
          // item.prices.forEach((price) => {
          //   price.isCheck = 0
          // })
        })
      }
    }
  },
  async mounted () {
    this.$loading({
      lock: true,
      text: this.$t('General.PleaseWaitFor', { action: this.$t('OrderFood.InitializingData') }),
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    try {
      await Promise.all([
        this.$store.dispatch('getFoodMenu'),
        this.$store.dispatch('getFoodSpec')
      ])
    } catch (error) {
      console.log(error)
      this.$message({
        message: this.$t('OrderFood.InitializingData') + this.$t('General.Fail'),
        type: 'error'
      })
    } finally {
      this.$loading().close()
    }

    this.id = this.$route.params.id
    // 如果id不為0，則為編輯模式
    if (this.id !== '0') {
      this.mode = 'edit'
      this.messageTitle = this.$t('OrderFoodMenuEdit.FoodCategoryEdit')
      this.handleGetMenuItem(this.id)
    }
    // 保留原始表單資料
    this.originalEditFormData = JSON.stringify(this.editForm)
  },
  methods: {
    /**
     * 處理取得規格資料
     * 1. 從 Vuex 取得規格資料
     * @param {string} id 餐點ID
     */
    handleGetMenuItem (id) {
      const menuItem = this.$store.getters.getMenuItem(id)
      if (menuItem) {
        Object.assign(this.editForm, _cloneDeep(menuItem))
        this.editForm.originalName = this.editForm.name
      }
      this.editForm.children.forEach((item, index) => {
        item.timestamp = this.getRandomTimestamp() // 用於 table row-key
        item.originalName = item.name
      })
      this.$nextTick(() => {
        this.initSortable()
      })
    },
    /**
     * 處理刪除餐點類別
     */
    handleClickDelete () {
      // msgbox 設定值
      const options = {
        title: this.$t('OrderFoodMenuEdit.IfDeleteTargetFoodMenu', { targetName: this.editForm.name || this.editForm.originalName }),
        message: this.$t('OrderFoodMenuEdit.DeleteFoodCategoryTip'),
        showClose: false,
        showCancelButton: true,
        cancelButtonText: this.$t('General.Cancel'),
        confirmButtonText: this.$t('General.OK'),
        confirmButtonClass: 'el-button--primary',
        dangerouslyUseHTMLString: true,
        callback: action => {
          if (action === 'confirm') {
            this.handleDeleteMenu()
          }
        }
      }
      this.$msgbox(options)
    },
    /**
     * 處理刪除規格
     */
    async handleDeleteMenu () {
      let isSuccessful = false
      const loading = this.$loading({
        lock: true,
        text: this.$t('General.PleaseWaitFor', { action: this.$t('General.Processing') }),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        const { status } = convertKeysToCamelCase((await apiOrderFood.deleteFoodMenu(this.id)).data)
        if (status === 1) {
          isSuccessful = true
          this.$router.go(-1)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.$message({
          message: this.$t('OrderFoodMenuEdit.FoodCategoryDelete') + (isSuccessful ? this.$t('General.Success') : this.$t('General.Fail')),
          type: isSuccessful ? 'success' : 'error'
        })
        loading.close()
      }
    },
    // 新增餐點品項
    addMenuOption () {
      const newChildren = {
        timestamp: this.getRandomTimestamp(), // 用於 table row-key
        name: '',
        sequence: this.editForm.children.length + 1,
        isCheck: 0,
        prices: [
          {
            priceType: 1, // 一般點數
            unitPrice: 0,
            isCheck: 0
          },
          {
            priceType: 2, // 現金點數
            unitPrice: 0,
            isCheck: 0
          }
        ],
        chooses: [], // 選擇的規格
        displaySpec: '' // 顯示規格
      }
      if (this.mode === 'edit') {
        newChildren.id = this.childrenIdTemplate
      }
      this.editForm.children.push(newChildren)
      this.$nextTick(() => {
        this.initSortable()
      })
    },
    getRandomTimestamp () {
      return `${Date.now()}-${Math.floor(Math.random() * 10000)}`
    },
    /**
     * 處理刪除規格選項
     * @param {number} index 規格選項索引
     */
    handleDeleteOption (index) {
      const targetChildren = this.editForm.children[index]
      if (this.mode === 'add' || (this.mode === 'edit' && targetChildren.id === this.childrenIdTemplate)) {
        this.editForm.children.splice(index, 1)
      } else if (this.mode === 'edit') {
        // msgbox 設定值
        const options = {
          message: this.$t('OrderFoodMenuEdit.IfDeleteTargetFoodItem', { targetName: targetChildren.name || targetChildren.originalName }),
          showClose: false,
          showCancelButton: true,
          cancelButtonText: this.$t('General.Cancel'),
          confirmButtonText: this.$t('General.OK'),
          confirmButtonClass: 'el-button--primary',
          dangerouslyUseHTMLString: true,
          callback: action => {
            if (action === 'confirm') {
              this.deleteChildren.push(this.editForm.children.splice(index, 1)[0])
            }
          }
        }
        this.$msgbox(options)
      }
    },
    // 初始化排序實例
    initSortable () {
      this.$nextTick(() => {
        this.$refs.sortableRef.destroy()
        this.$refs.sortableRef.init()
      })
    },
    // 處理拖曳結束
    handleDragEnd ({ oldIndex, newIndex }) {
      const movedItem = this.editForm.children.splice(oldIndex, 1)[0]
      this.editForm.children.splice(newIndex, 0, movedItem)
      this.editForm.children.forEach((item, index) => {
        item.sequence = index + 1
      })
    },
    /**
     * 處理打開規格對話框
     * 1. 帶入目前點選品項的資料
     * @param {number} index 品項索引
     */
    handleOpenSpecDialog (index) {
      this.targetMenuItemIndex = index // 目前品項索引
      this.targetMenuItemChooses = [...this.editForm.children[index].chooses] // 目前品項選擇的規格
      this.$refs.selectSpecDialogRef.open()
    },
    /**
     * 處理選中規格
     * @param {object} {index: 目標品項索引, selectedSpec: 勾選的規格}
     */
    handleSelectedSpec ({ index, selectedSpec }) {
      const targetChildren = this.editForm.children[index]
      if (targetChildren) {
        targetChildren.chooses = [...selectedSpec]
        targetChildren.displaySpec = getDisplaySpec(targetChildren.chooses, ', ')
      }
    },
    // 處理儲存
    async handleSave () {
      try {
        await this.$refs.editFormRef.validate()
      } catch (error) {
        console.log(error)
        return
      }

      let isSuccessful = false
      try {
        this.loading = this.$loading({
          lock: true,
          text: this.$t('General.PleaseWaitFor', { action: this.$t('General.Saving') }),
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        const params = {
          name: this.editForm.name,
          sequence: this.mode === 'add' ? this.$store.getters.getMenuListLatestSequence + 1 : this.editForm.sequence,
          isCheck: this.editForm.isCheck,
          children: []
        }
        this.editForm.children.forEach((item, index) => {
          params.children.push({
            name: item.name,
            sequence: index + 1,
            isCheck: item.isCheck,
            prices: [...item.prices],
            chooses: item.chooses.flatMap(spec => spec.children).filter(opt => opt.isOption === 1).map(opt => { return { id: opt.id } })
          })
        })

        if (this.mode === 'add') {
          const { status } = convertKeysToCamelCase((await apiOrderFood.addFoodMenu(convertKeysToPascalCase(params))).data)
          if (status === 1) {
            isSuccessful = true
            this.$message({
              message: this.messageTitle + this.$t('General.Success'),
              type: 'success'
            })
            this.$router.go(-1)
          }
        } else if (this.mode === 'edit') {
          params.children.forEach((item, index) => {
            // 如果是編輯模式，則帶入原本的id
            this.$set(item, 'id', this.editForm.children[index].id)
          })
          // 如果有刪除的餐點品項
          if (this.deleteChildren.length > 0) {
            this.deleteChildren.forEach((item) => {
              params.children.push({
                ...item,
                isCheck: -1 // 刪除
              })
            })
          }

          const { status } = convertKeysToCamelCase((await apiOrderFood.updateFoodMenu(this.id, convertKeysToPascalCase(params))).data)
          if (status === 1) {
            isSuccessful = true
            this.$message({
              message: this.messageTitle + this.$t('General.Success'),
              type: 'success'
            })
            this.$router.go(-1)
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        if (!isSuccessful) {
          this.$message({
            message: this.messageTitle + this.$t('General.Fail'),
            type: 'error'
          })
        }
        this.loading && this.loading.close()
      }
    },
    /**
     * 處理點擊取消
     */
    handleClickCancel () {
      // 若表單有異動，則跳出提示
      if (JSON.stringify(this.editForm) !== this.originalEditFormData) {
        this.$msgbox({
          title: '尚未儲存',
          message: this.$t('OrderFoodItemManagement.IfLeaveChangeNotSaved'),
          showCancelButton: true,
          confirmButtonText: this.$t('General.Leave'),
          cancelButtonText: this.$t('OrderFoodItemManagement.KeepEdit'),
          confirmButtonClass: 'el-button--danger',
          callback: action => {
            if (action === 'confirm') {
              this.$router.go(-1)
            }
          }
        })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.food-item-edit {
    @include FoodItemEdit();
    &__form-el {
      width: 100%;
    }
    ::v-deep .el-form-item__label, ::v-deep .el-form-item__content {
      text-align: left;
    }
    ::v-deep .el-radio {
      &:not(:last-child) {
        margin-right: 20px;
      }
    }
    &__price-container {
      display: flex;
      flex-direction: column;
    }
    &__price-radio-wrapper {
      margin-bottom: 8px;
    }
    &__spec-btn {
      width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 7px;
    }
    &__menu-name-input {
      width: 420px;
      margin-right: 30px;
    }
    &__form-label {
      display: flex;
      align-items: center;
    }
}
</style>
